import AxiosService from '@/services/api/AxiosService';
import ApiStatus from '@/entities/enums/apiStatuses';
import ReleaseNotePreview from '@/entities/ReleaseNotePreview';
import ReleaseNoteDetail from '@/entities/ReleaseNoteDetail';
import AppConfig from '@/configLoader';
//fallback values can be removed after some time but now we need them to handle case when config is not reloaded
const WP_REMOTE = AppConfig.getConfig().wp_release_notes?.address || 'https://www.loghub.sk';
const WP_POST_CATEGORY_ID = AppConfig.getConfig().wp_release_notes?.categoryId || 53;
export default class ReleaseNotesRepository {
    constructor(ctx) {
        this.ctx = ctx;
    }
    async getAllReleaseNotesPreview() {
        let url = `${WP_REMOTE}/wp-json/wp/v2/posts?categories=${WP_POST_CATEGORY_ID}&_fields=id,title,excerpt&t=${new Date().getTime()}`;
        let response = await AxiosService.getDataFrom3rdPartyServer(url, this.ctx);
        if (response.status != ApiStatus.SUCCESS)
            return [];
        else
            return ReleaseNotePreview.fromApi(response.data);
    }
    async getReleaseNoteDetail(id) {
        let url = `${WP_REMOTE}/wp-json/wp/v2/posts/${id}?_fields=id,title,content,link&t=${new Date().getTime()}`;
        let response = await AxiosService.getDataFrom3rdPartyServer(url, this.ctx);
        if (response.status != ApiStatus.SUCCESS)
            return new ReleaseNoteDetail();
        else
            return ReleaseNoteDetail.fromApi(response.data);
    }
}
